export default __webpack_public_path__ + "static/media/demo_2.9750d2c3.png";